import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';

import type { SavedTourist } from 'src/routes/Checkout/store/client/types';

import SavedTouristOptionBody from '../SavedTouristOptionBody';

type Props = OptionProps<SavedTourist> & {
  isMobile: boolean;
  onClickOption: () => void;
  deleteSavedTourist: (tourist: SavedTourist) => void;
};

const TouristNameOption = (props: Props): JSX.Element => {
  const { onClickOption, deleteSavedTourist, isMobile, data } = props;

  return (
    <components.Option {...props}>
      <SavedTouristOptionBody
        data={data}
        onClickOption={onClickOption}
        deleteSavedTourist={deleteSavedTourist}
        isMobile={isMobile}
      />
    </components.Option>
  );
};

export default TouristNameOption;
